import React, { useContext, useEffect, useState } from 'react'
import { CButton, CFormCheck, CModal, CModalBody, CModalFooter, CModalHeader } from '@coreui/react'
import CustomDescriptionBox from 'src/components/CustomDescriptionBox'
import ImageUploader from 'src/components/ImageUploader/ImageUploader'
import AttachLink from '../attachLink'
import { GlobalContext } from 'src/views/context/GlobalState'
import { getThumbnail, validateLink } from 'src/views/utils/helper'
import Loading from 'react-fullscreen-loading'
import { AppContext } from 'src/views/context/app'
import useAxios from 'axios-hooks'
import { SYSTEM_METADATA_API } from 'src/views/utils/urls'
import ParaIcon from '../../../assets/paragrapgh-icon.svg'
import { isEmpty } from 'lodash'
import DesignSettingOverlay from '../designSettingOverlay'
import PaintBrushIcon from '../../../assets/paint-brush-icon.svg'

const RosemaryRecentStoriesModal = ({
  componentData,
  modifyData,
  modalSpecificData,
  onCancel,
  isAdvancedEditAllowed,
}) => {
  const { userSessionObj } = useContext(GlobalContext)
  const { loader, setLoader } = useContext(AppContext)
  const [imageS3key, setImageS3key] = useState('')
  const [title, setTitle] = useState('')
  const [alignment, setAlignment] = useState('')
  const [heading1, setHeading1] = useState('')
  const [heading2, setHeading2] = useState('')
  const [description, setDescription] = useState('')
  const [link, setLink] = useState({
    type: '',
    data: {},
  })

  const [errorData, setErrorData] = useState({})
  const [leftImageData, setLeftImageData] = useState([])
  const [rightImageData, setRightImageData] = useState([])
  const [styleConfig, setStyleConfig] = useState({})
  const [designSettingOptions, setDesignSettingOptions] = useState([])

  const [{ data: categoryList, loading: categoryListLoading }] = useAxios({
    url: SYSTEM_METADATA_API,
    method: 'get',
  })

  useEffect(() => {
    setLoader(categoryListLoading)
  }, [categoryListLoading])

  useEffect(() => {
    const leftImgData = [
      {
        title: '',
        id: 'leftImg',
        width: 771,
        height: 597,
        divwidth: '10.2rem',
        divheight: '7.8rem',
        assetId: '',
        titleDisabled: true,
        setAssetId: (id) => {},
        setImage: (obj) => {
          clearError('imageS3key')
          setImageS3key(obj?.s3Key)
        },
        onRemoveImg: () => {
          setImageS3key('')
        },
        imageUrl: '',
      },
    ]
    const rightImgData = [
      {
        title: '',
        id: 'rightImg',
        width: 771,
        height: 597,
        divwidth: '10.2rem',
        divheight: '7.8rem',
        assetId: '',
        titleDisabled: true,
        setAssetId: (id) => {},
        setImage: (obj) => {
          clearError('imageS3key')
          setImageS3key(obj?.s3Key)
        },
        onRemoveImg: () => {
          setImageS3key('')
        },
        imageUrl: '',
      },
    ]
    let tempdata = componentData.data

    if (tempdata?.style_config) {
      setStyleConfig(tempdata?.style_config)
    }

    setTitle(tempdata.title)
    setAlignment(tempdata.aligned)
    setHeading1(tempdata.heading_1)
    setHeading2(tempdata.heading_2)
    setDescription(tempdata.description)
    setLink(tempdata.link)
    setImageS3key(tempdata.image_s3key)

    if (tempdata.aligned === 'LEFT') {
      leftImgData[0]['assetId'] = tempdata.image_s3key
      leftImgData[0]['imageUrl'] = getThumbnail(
        userSessionObj?.session_data?.cf_domain_name,
        tempdata.image_s3key,
      )
    }
    if (tempdata.aligned === 'RIGHT') {
      rightImgData[0]['assetId'] = tempdata.image_s3key
      rightImgData[0]['imageUrl'] = getThumbnail(
        userSessionObj?.session_data?.cf_domain_name,
        tempdata.image_s3key,
      )
    }
    setRightImageData(rightImgData)
    setLeftImageData(leftImgData)
  }, [componentData])

  const clearError = (type) => {
    let temp = errorData
    temp[`${type}`] = ''
    setErrorData({ ...temp })
  }

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (imageS3key.trim().length === 0) {
      isFormValid = false
      temp.imageS3key = 'Upload Image!'
    }

    if (link.type && !validateLink(link).isValid) {
      isFormValid = false
      temp.link = validateLink(link).error
    }

    setErrorData({ ...temp })
    return isFormValid
  }

  const handleSave = () => {
    if (!validateInfo()) return

    let elementObj = {
      image_s3key: imageS3key,
      title: title,
      aligned: alignment,
      heading_1: heading1,
      heading_2: heading2,
      description: description,
      link: link,
      style_config: styleConfig,
    }

    modifyData(componentData.id, elementObj)
  }
  const onAlignmentChange = (event) => {
    const { value } = event.target
    clearError('imageS3key')
    setAlignment(value)

    const leftImgData = [
      {
        title: '',
        id: 'leftImg',
        width: 771,
        height: 597,
        divwidth: '10.2rem',
        divheight: '7.8rem',
        assetId: '',
        titleDisabled: true,
        setAssetId: (id) => {},
        setImage: (obj) => {
          clearError('imageS3key')
          setImageS3key(obj?.s3Key)
        },
        onRemoveImg: () => {
          setImageS3key('')
        },
        imageUrl: '',
      },
    ]
    const rightImgData = [
      {
        title: '',
        id: 'rightImg',
        width: 771,
        height: 597,
        divwidth: '10.2rem',
        divheight: '7.8rem',
        assetId: '',
        titleDisabled: true,
        setAssetId: (id) => {},
        setImage: (obj) => {
          clearError('imageS3key')
          setImageS3key(obj?.s3Key)
        },
        onRemoveImg: () => {
          setImageS3key('')
        },
        imageUrl: '',
      },
    ]

    setRightImageData(leftImgData)
    setLeftImageData(rightImgData)
  }

  const getStyleConfig = (keyArr = []) => {
    if (!componentData?.data?.style_config) {
      return []
    }
    let stylesArr = []
    for (let i = 0; i < keyArr.length; i++) {
      const key = keyArr[i]
      let styleObj = componentData?.data?.style_config[key]
      stylesArr.push(styleObj)
    }
    return stylesArr
  }

  const handleStyleSave = (data) => {
    let tempStyleObj = styleConfig
    for (let i = 0; i < data.length; i++) {
      const ele = data[i]
      tempStyleObj[ele.key] = ele
    }
    setStyleConfig({ ...tempStyleObj })
    setDesignSettingOptions([])
  }

  return (
    <CModal scrollable size="lg" className="recent-stories-modal" visible={true}>
      {!isEmpty(designSettingOptions) && (
        <DesignSettingOverlay
          width={'36%'}
          options={designSettingOptions}
          onCancel={() => setDesignSettingOptions([])}
          handleSave={(data) => handleStyleSave(data)}
        />
      )}
      <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />
      <CModalHeader
        style={{ borderBottom: 0, paddingBottom: 0 }}
        className="d-flex justify-content-center align-items-center"
      >
        <p style={{ fontSize: '20px' }} className="mb-0 mx-3">
          <b style={{ fontWeight: '500' }}>Edit Card Elements</b>
        </p>
        {isAdvancedEditAllowed && componentData?.data?.style_config && (
          <div
            className={`h-[30px] w-[30px] d-flex justify-content-center align-items-center rounded-full overflow-hidden "`}
          >
            <img
              src={PaintBrushIcon}
              alt="PaintBrushIcon"
              className="cursor-pointer w-full h-full"
              onClick={() => {
                setDesignSettingOptions(
                  getStyleConfig([
                    'component_background',
                    'section_title',
                    'heading1',
                    'heading2',
                    'paragraph',
                  ]),
                )
              }}
            />
          </div>
        )}
      </CModalHeader>
      <CModalBody className="px-5 static-scrollbar-class border d-flex flex-column justify-content-between align-items-around">
        <div>
          <div className="">
            <h6 style={{ fontSize: '13px' }} className="">
              SECTION TITLE
            </h6>
            <CustomDescriptionBox
              limit={50}
              rows={1}
              value={title}
              onChange={(value) => setTitle(value)}
              style={{ fontSize: '12px' }}
              limitFontSize={'11px'}
            />
          </div>

          <div className="mt-1">
            <h6 style={{ fontSize: '13px' }} className="">
              Select the Card Style
            </h6>
            <div className="mt-4 flex justify-content-between">
              <div className="d-flex flex-column justify-content-center ">
                <CFormCheck
                  type="radio"
                  id="leftcard"
                  label="Left side Image with Right side Text"
                  value="LEFT"
                  className="recent-stories-radio"
                  checked={alignment === 'LEFT'}
                  onChange={(e) => onAlignmentChange(e)}
                />
                <div
                  style={{
                    border: `1.5px solid ${alignment === 'LEFT' ? '#2172eb' : '#707070'}  `,
                  }}
                  className="recent-stories-img-box flex justify-content-between align-items-center px-2 py-2"
                >
                  <div className="text-center mt-2">
                    {<ImageUploader data={leftImageData} isDisabled={alignment !== 'LEFT'} />}
                    <span style={{ fontSize: '9px', color: '#707070' }}>
                      771px X 597px , maximum size 3 MB
                    </span>
                  </div>
                  <div className=" mr-1">
                    <img src={ParaIcon} alt="para img" />
                  </div>
                </div>
                <div className="message-text error-message">
                  <p>{alignment === 'LEFT' && errorData.imageS3key}&#10240;</p>
                </div>
              </div>

              <div className="d-flex flex-column justify-content-center ">
                <CFormCheck
                  type="radio"
                  id="rigthcard"
                  label="Right side Image with Left side Text"
                  value="RIGHT"
                  className="recent-stories-radio"
                  checked={alignment === 'RIGHT'}
                  onChange={(e) => onAlignmentChange(e)}
                />
                <div
                  style={{
                    border: `1.5px solid ${alignment === 'RIGHT' ? '#2172eb' : '#707070'}  `,
                  }}
                  className="recent-stories-img-box flex justify-content-between align-items-center px-2 py-2"
                >
                  <div className=" ml-1">
                    <img src={ParaIcon} alt="para img" />
                  </div>
                  <div className="text-center mt-2">
                    {<ImageUploader data={rightImageData} isDisabled={alignment !== 'RIGHT'} />}
                    <span style={{ fontSize: '9px', color: '#707070' }}>
                      771px X 597px , maximum size 3 MB
                    </span>
                  </div>
                </div>
                <div className="message-text error-message">
                  <p>{alignment === 'RIGHT' && errorData.imageS3key}&#10240;</p>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-1">
            <h6 style={{ fontSize: '13px' }} className="">
              Heading1
            </h6>
            <CustomDescriptionBox
              limit={50}
              rows={1}
              value={heading1}
              onChange={(value) => setHeading1(value)}
              style={{ fontSize: '12px' }}
              limitFontSize={'11px'}
            />
          </div>
          <div className="mt-1">
            <h6 style={{ fontSize: '13px' }} className="">
              Heading2
            </h6>
            <CustomDescriptionBox
              limit={50}
              rows={1}
              value={heading2}
              onChange={(value) => setHeading2(value)}
              style={{ fontSize: '12px' }}
              limitFontSize={'11px'}
            />
          </div>
          <div className="mt-1">
            <h6 style={{ fontSize: '13px' }} className="">
              Paragraph
            </h6>
            <CustomDescriptionBox
              limit={500}
              rows={3}
              value={description}
              onChange={(value) => setDescription(value)}
              style={{ fontSize: '12px' }}
              limitFontSize={'11px'}
            />
          </div>
          <div>
            <AttachLink
              linkData={link}
              id={'attachlink'}
              categoryData={
                categoryList
                  ? categoryList?.data.filter(
                      (info, idx) => info.type === 'category' && info.status,
                    )
                  : []
              }
              setLinkData={(value) => {
                clearError('link')
                setLink(value)
              }}
            />
          </div>
          <div className="message-text error-message">
            <p>{errorData.link}</p>
          </div>
        </div>
        <span className="mt-2" style={{ fontSize: '12px' }}>
          * Leave a section blank to remove it from the component. Do not fill any details.
        </span>
      </CModalBody>
      <CModalFooter style={{ borderTop: 0 }} className="px-5">
        <div className="pb-3">
          <CButton
            style={{ color: 'black', border: '1px solid black', fontSize: '1.1rem' }}
            className="mx-4 bg-white rounded-1 btn-focus-none"
            onClick={onCancel}
          >
            Cancel
          </CButton>
          <CButton
            style={{ fontSize: '1.1rem' }}
            className=" bg-black rounded-1 btn-focus-none px-3"
            onClick={handleSave}
          >
            Save
          </CButton>
        </div>
      </CModalFooter>
    </CModal>
  )
}

export default RosemaryRecentStoriesModal
